/* global axios */
import ApiClient from './ApiClient';

class KanbanCardProductsAPI extends ApiClient {
  constructor() {
    super('', { accountScoped: true });
  }

  // Listar produtos de um card
  getProducts(pipelineId, kanbanCardId) {
    return axios.get(
      `${this.baseUrl()}/kanban/pipelines/${pipelineId}/cards/${kanbanCardId}/products`
    );
  }

  // Mostrar produto específico de um card
  getProduct(pipelineId, kanbanCardId, productId) {
    return axios.get(
      `${this.baseUrl()}/kanban/pipelines/${pipelineId}/cards/${kanbanCardId}/products/${productId}`
    );
  }

  // Adicionar produto a um card
  addProduct(pipelineId, kanbanCardId, productData) {
    return axios.post(
      `${this.baseUrl()}/kanban/pipelines/${pipelineId}/cards/${kanbanCardId}/products`,
      {
        kanban_card_product: productData,
      }
    );
  }

  // Atualizar produto de um card
  updateProduct(pipelineId, kanbanCardId, productId, productData) {
    return axios.patch(
      `${this.baseUrl()}/kanban/pipelines/${pipelineId}/cards/${kanbanCardId}/products/${productId}`,
      {
        kanban_card_product: productData,
      }
    );
  }

  // Remover produto de um card
  removeProduct(pipelineId, kanbanCardId, productId) {
    return axios.delete(
      `${this.baseUrl()}/kanban/pipelines/${pipelineId}/cards/${kanbanCardId}/products/${productId}`
    );
  }
}

export default new KanbanCardProductsAPI();
